import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { configureChatRollout } from '@odo/shared-ui';
import App from './App';
import { ErrorFallback } from './observability/ErrorFallback';
import { initSentry } from '@odo/shared-ui/observability/sentry';
import './index.css';

initSentry({ dsn: import.meta.env.VITE_FILES_VIEWER_SENTRY_DSN, release: __APP_VERSION__ });
// Chat rollout: stage 1 { 'v1', true }, stage 2 { 'v2', true }, stage 3 { 'v2', false };
// unplug V2 with { 'v1', false }.
configureChatRollout({ defaultVersion: 'v1', canSwitch: true });

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <Sentry.ErrorBoundary fallback={ErrorFallback} onReset={() => window.location.reload()}>
            <App />
        </Sentry.ErrorBoundary>
    </React.StrictMode>
);
